// Synthesizes a short, gentle two-note chime via the Web Audio API so we don't
// need to ship a binary audio asset. `getAudioContext` must be called from a
// real user-gesture handler first (e.g. a submit/click) so browser autoplay
// policies don't block it.

let ctx = null;

export function getAudioContext() {
  if (!ctx) {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    ctx = new AudioCtx();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function playNote(audioCtx, freq, startTime, duration) {
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(0.12, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  osc.connect(gain);
  gain.connect(audioCtx.destination);
  osc.start(startTime);
  osc.stop(startTime + duration);
}

export function playChime() {
  if (!ctx) return;
  const now = ctx.currentTime;
  playNote(ctx, 880, now, 0.35);
  playNote(ctx, 1318.5, now + 0.12, 0.4);
}
